import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  // const error = useRouteError();
  // console.error(error);

  return (
    <div className="error-page">
      {/* <h2>{error.status}</h2> */}
      {/* <p> */}
      {/*   <i>{error.statusText || error.data}</i> */}
      {/* </p> */}
      <p>Sorry, an unexpected error has occurred.</p>
    </div>
  );
}
